import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-warmGray py-24 px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3">
          <FadeIn direction="right" data-id="element-4">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm h-full" data-id="element-5">
              <h3 className="text-2xl font-bold mb-8 font-heading text-charcoal flex items-center gap-3" data-id="element-6">
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-7">
                <li className="flex items-start gap-4" data-id="element-8">
                  <CheckCircle2Icon className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-9" />
                  <div data-id="element-10">
                    <span className="font-bold block mb-1" data-id="element-11">
                      The "Tech Support" Child:
                    </span>
                    <span className="text-charcoal/80" data-id="element-12">
                      Who wants their parents to be confident and independent.
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-13">
                  <CheckCircle2Icon className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-14" />
                  <div data-id="element-15">
                    <span className="font-bold block mb-1" data-id="element-16">Parents 65+:</span>
                    <span className="text-charcoal/80" data-id="element-17">
                      Who want to stay connected to the family without feeling
                      like a "bother."
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-18">
                  <CheckCircle2Icon className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-19" />
                  <div data-id="element-20">
                    <span className="font-bold block mb-1" data-id="element-21">Families:</span>
                    <span className="text-charcoal/80" data-id="element-22">
                      Who want to share photos and videos without a 20-minute
                      tech lesson attached.
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-23">
            <div className="bg-cream p-8 md:p-10 rounded-3xl border border-warmGray h-full" data-id="element-24">
              <h3 className="text-2xl font-bold mb-8 font-heading text-warmBrown flex items-center gap-3" data-id="element-25">
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-26">
                <li className="flex items-start gap-4" data-id="element-27">
                  <XCircleIcon className="w-6 h-6 text-warmBrown/60 shrink-0 mt-1" data-id="element-28" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-29">
                    Parents who already manage digital accounts and storage like
                    experts.
                  </span>
                </li>
                <li className="flex items-start gap-4" data-id="element-30">
                  <XCircleIcon className="w-6 h-6 text-warmBrown/60 shrink-0 mt-1" data-id="element-31" />
                  <span className="text-charcoal/80 leading-relaxed" data-id="element-32">
                    People looking for advanced IT or coding training.
                  </span>
                </li>
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}